const CALENDLY_URLS = {
  es: "https://calendly.com/equalitasabogados/regularizacion2026",
  en: "https://calendly.com/equalitasabogados/free-assessment-regularization-2026?primary_color=1a3c2a",
};

export const getCalendlyUrl = (locale: string) => {
  // FR users are routed to the Spanish Calendly (no dedicated FR booking page)
  if (locale === "fr") return CALENDLY_URLS.es;
  return CALENDLY_URLS[locale as keyof typeof CALENDLY_URLS] ?? CALENDLY_URLS.es;
};

let loadPromise: Promise<void> | null = null;

function loadCalendly(): Promise<void> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    // CSS
    if (!document.querySelector('link[href*="calendly"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);
    }

    // JS
    if ((window as any).Calendly) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Calendly"));
    document.head.appendChild(script);
  });

  return loadPromise;
}

export const openCalendly = async (locale: string) => {
  await loadCalendly();
  (window as any).Calendly?.initPopupWidget({ url: getCalendlyUrl(locale) });
};
